export enum SubscriptionType {
  None = 0,
  Trial = 1,
  Licensed = 2,
  Inherited = 3,
  MonthlyLicenseTrial = 4,
  InheritedMspTrial = 5,
  Frat = 6,
  BasicMonthly = 7,
}
